/**
 * Webpage export configuration
 */

import type { ExportColumnConfig } from '@/components/export/universal/types';

export const WEBPAGE_COLUMNS: readonly ExportColumnConfig[] = [
  { id: 'url', label: 'URL', defaultSelected: true },
  { id: 'status', label: 'Status', defaultSelected: true },
  { id: 'source', label: 'Source' },
  { id: 'type', label: 'Type' },
  { id: 'component', label: 'Component' },
  { id: 'service', label: 'Service' },
  { id: 'private', label: 'Private' },
  { id: 'history', label: 'History' },
  { id: 'first_seen', label: 'First Seen', defaultSelected: true },
  { id: 'last_seen', label: 'Last Seen', defaultSelected: true },
];
